import React from 'react';
import DropdownSelector from './DropdownSelector';

export default function NumberSelector(props) {
  const handleChange = function (field) {
    props.onChange({name: field.name, value: field.value});
  };
  const selectorProps = {
    id: props.id,
    label: props.label,
    name: props.name,
    value: props.value,
    message: props.message,
  };
  if (props.options) selectorProps.options = props.options;
  else {
    const min = props.min || 0;
    const max = props.max || min + 10;
    const increment = props.increment || 1;
    selectorProps.options = [];
    for (let value = min; value <= max; value = value + increment) {
      selectorProps.options.push({name: value, value});
    }
  }

  return (
    <DropdownSelector {...selectorProps} onChange={handleChange} />
  );
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/NumberSelector.jsx